import React, { Component } from "react";
import { connect } from "react-redux";
import AddLink from "../components/SocialMedia";
import { onLogout } from "../../../../auth/authActions";
import { close_snack_bar } from "../../../../../store/actions/snackbarActions";
import {
  viewAllLinks,
  UploadaddLink,
  UploadupdateLink,
  viewLinkById,
  setModalfalse,
} from "../../../adminActions";
export class Controller extends Component {
  render() {
    return <AddLink {...this.props} />;
  }
}
export const mapStateToProps = (store) => {
  return {
    login: store.login,
    loader: store.loader,
    snackbar: store.snackbar,
    client: store.client,
  };
};
export const mapDispatchToProps = (dispatch) => {
  return {
    viewAllLinks: (
      token,
      user_id,
      searchInput,
      page,
      pageSize,
      selectedDate,
      selectedTime,
      selectedStatus
    ) => {
      dispatch(
        viewAllLinks(
          token,
          user_id,
          searchInput,
          page,
          pageSize,
          selectedDate,
          selectedTime,
          selectedStatus
        )
      );
    },
    viewLinkById: (user_id, token) => {
      dispatch(viewLinkById(user_id, token));
    },

    UploadaddLink: (
      token,
      user_id,
      Facebook,
      Instagram,
      WhatsApp,
      Browser,
      Snapchat,
      GoogleMaps,
      Twitter,
      LinkedIn,
      Telegram,
      YouTube,
      Pinterest,
      PDFDownloader,
      profileImage,
      coverImage,
      heading,
      mediaType,
      mobile,
      BusinessWhatsApp,
      Skype,
      massenger,
      wechat,
      FaceTime,
      showAllReviews,
      tagLine,
      login_id
    ) => {
      dispatch(
        UploadaddLink(
          token,
          user_id,
          Facebook,
          Instagram,
          WhatsApp,
          Browser,
          Snapchat,
          GoogleMaps,
          Twitter,
          LinkedIn,
          Telegram,
          YouTube,
          Pinterest,
          PDFDownloader,
          profileImage,
          coverImage,
          heading,
          mediaType,
          mobile,
          BusinessWhatsApp,
          Skype,
          massenger,
          wechat,
          FaceTime,
          showAllReviews,
          tagLine,
          login_id
        )
      );
    },
    UploadupdateLink: (
      token,
      user_id,
      id,
      Facebook,
      Instagram,
      WhatsApp,
      Browser,
      Snapchat,
      GoogleMaps,
      Twitter,
      LinkedIn,
      Telegram,
      YouTube,
      Pinterest,
      PDFDownloader,
      heading,
      mediaType,
      mobile,
      BusinessWhatsApp,
      Skype,
      massenger,
      wechat,
      FaceTime,
      coverImage,
      newcoverImage,
      profileImage,
      newprofileImage,
      showAllReviews,
      tagLine
    ) => {
      dispatch(
        UploadupdateLink(
          token,
          user_id,
          id,
          Facebook,
          Instagram,
          WhatsApp,
          Browser,
          Snapchat,
          GoogleMaps,
          Twitter,
          LinkedIn,
          Telegram,
          YouTube,
          Pinterest,
          PDFDownloader,
          heading,
          mediaType,
          mobile,
          BusinessWhatsApp,
          Skype,
          massenger,
          wechat,
          FaceTime,
          coverImage,
          newcoverImage,
          profileImage,
          newprofileImage,
          showAllReviews,
          tagLine
        )
      );
    },

    setModalfalse: () => {
      dispatch(setModalfalse());
    },
    onLogout: (token) => {
      dispatch(onLogout(token));
    },
    close_snack_bar: () => {
      dispatch(close_snack_bar());
    },
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Controller);
